import { BreachPathDetailsWebComponent } from './component/BreachPathDetailsWebComponent';
import { WEB_COMPONENT_BREACH_PATH_DETAILS } from '../../webcomponents.constants';

export { BreachPathDetailsWebComponent };

window.customElements.define(WEB_COMPONENT_BREACH_PATH_DETAILS, BreachPathDetailsWebComponent);
